module.exports = __webpack_public_path__ + "static/media/code.7c5224b0.svg";